import { Injectable, signal } from "@angular/core";

import { OverlayCommonService } from "@components/shared/overlay/overlay-common.service";

@Injectable({
  providedIn: "root",
})
export class PurchaseOrdersOverlayService extends OverlayCommonService {
  lineItemsCount = signal<number>(0);

  deliveriesCount = signal<number>(0);

  constructor() {
    super();
  }

  override setCountersToLoadingState() {
    super.setCountersToLoadingState();
    this.lineItemsCount.set(null);
    this.deliveriesCount.set(null);
  }

  override setCountersEmptyState() {
    super.setCountersEmptyState();
    this.lineItemsCount.set(0);
    this.deliveriesCount.set(0);
  }
}
